<template>

  <div class="padded">
    <h1 class="text-primary">Categories</h1>
    <el-alert
      type="info"
      title="Caution!"
      description="Changing contents here has far reaching consquences on the data, please make sure your changes won't affect existing data."
      show-icon
      :closable="false" />
      <br />
      <el-collapse v-model="menu" accordion>

        <el-collapse-item name="actions">
          <template slot="title">
              <span class="text-info">Actions&nbsp;<i class="header-icon fa fa-asterisk"></i></span>
            </template>
            <coming-soon />
        </el-collapse-item>

        <el-collapse-item name="sites">
          <template slot="title">
              <span class="text-info">Sites&nbsp;<i class="header-icon fa fa-stopwatch"></i></span>
            </template>
            <coming-soon />
        </el-collapse-item>

        <el-collapse-item name="maint">
          <template slot="title">
              <span class="text-info">Projects &amp; Maintenance&nbsp;<i class="header-icon fa fa-wrench"></i></span>
            </template>
            <coming-soon />
        </el-collapse-item>

        <el-collapse-item name="property">
          <template slot="title">
              <span class="text-info">Property&nbsp;<i class="header-icon fa fa-home"></i></span>
            </template>
            <coming-soon />
        </el-collapse-item>

      </el-collapse>

  </div>

</template>

<script>

import ComingSoon from '@/components/settings/ComingSoon'

export default {

  components: {
    ComingSoon
  },

  data () {
    return {
      menu: 'actions'
    }
  }
}

</script>



// WEBPACK FOOTER //
// Categories.vue?e9180356